import { mutatorAction } from 'satcheljs';
import { assignOpenShiftsPollingState } from '../store/assignOpenShiftsPollingState';
import { AssignOpenShiftsActiveJob, UndoData } from '../store/schema/AssignOpenShiftsPollingStateSchema';
import { JobStatus } from 'sh-models/job/SmartScheduleGenerationJobStatusEntity';
export type { FailureData, UndoData } from '../store/schema/AssignOpenShiftsPollingStateSchema';

export const setAssignOpenShiftsJob = mutatorAction(
    'setAssignOpenShiftsJob',
    function setAssignOpenShiftsJob(job: AssignOpenShiftsActiveJob) {
        assignOpenShiftsPollingState().activeJob = { ...job };
    }
);

export const updateAssignOpenShiftsJobStatus = mutatorAction(
    'updateAssignOpenShiftsJobStatus',
    function updateAssignOpenShiftsJobStatus(status: JobStatus) {
        if (assignOpenShiftsPollingState().activeJob) {
            assignOpenShiftsPollingState().activeJob.status = status;
        }
    }
);

export const clearAssignOpenShiftsJob = mutatorAction(
    'clearAssignOpenShiftsJob',
    function clearAssignOpenShiftsJob() {
        assignOpenShiftsPollingState().activeJob = undefined;
    }
);

export const setShowSuccessToast = mutatorAction(
    'setShowSuccessToast',
    function setShowSuccessToast(value: boolean, undoData?: UndoData, successCount?: number) {
        assignOpenShiftsPollingState().showSuccessToast = value;
        if (value) {
            assignOpenShiftsPollingState().undoData = undoData;
            assignOpenShiftsPollingState().successCount = successCount;
        } else {
            assignOpenShiftsPollingState().partialSuccessData = undefined;
            assignOpenShiftsPollingState().undoData = undefined;
            assignOpenShiftsPollingState().successCount = undefined;
        }
    }
);

export const setPartialSuccessToast = mutatorAction(
    'setPartialSuccessToast',
    function setPartialSuccessToast(assigned: number, total: number) {
        assignOpenShiftsPollingState().partialSuccessData = { assigned, total };
        assignOpenShiftsPollingState().showSuccessToast = true;
    }
);

export const setShowFailureToast = mutatorAction(
    'setShowFailureToast',
    function setShowFailureToast(tagId: string, teamId: string) {
        assignOpenShiftsPollingState().failureData = { tagId, teamId };
        assignOpenShiftsPollingState().showFailureToast = true;
    }
);

export const clearFailureToast = mutatorAction(
    'clearFailureToast',
    function clearFailureToast() {
        assignOpenShiftsPollingState().showFailureToast = false;
        assignOpenShiftsPollingState().failureData = undefined;
    }
);

export const setShowCancelledToast = mutatorAction(
    'setShowCancelledToast',
    function setShowCancelledToast(value: boolean) {
        assignOpenShiftsPollingState().showCancelledToast = value;
    }
);
